module.exports = __webpack_public_path__ + "static/img/service-avatar.da89ac90.png";